import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import jp from './i18n/jp';

i18next.addResourceBundle('en', 'sessionHistory', en);
i18next.addResourceBundle('jp', 'sessionHistory', jp);

const SessionHistoryConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/session-history',
			exact: true,
			component: React.lazy(() => import('./SessionHistory'))
		}
	]
};

export default SessionHistoryConfig;
